import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, FileBarChart2, Sparkles, Bell } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Bottom tab bar for mobile (md and below). 4 primary destinations.
 * Hidden on lg+. Sticky to viewport bottom.
 */
const TABS = [
    { to: "/dashboard",     icon: Home,          label: "Кабінет" },
    { to: "/reports",       icon: FileBarChart2, label: "Звіти" },
    { to: "/strategy",      icon: Sparkles,      label: "Стратегія" },
    { to: "/notifications", icon: Bell,          label: "Сповіщ.", badgeKey: "unread" },
];

export default function BottomTabBar() {
    const location = useLocation();
    const [unread, setUnread] = useState(0);

    useEffect(() => {
        let cancelled = false;
        const load = () => api.get("/notifications?limit=1")
            .then(r => { if (!cancelled) setUnread(r.data?.unread || 0); })
            .catch(() => {});
        load();
        const t = setInterval(load, 60_000);
        return () => { cancelled = true; clearInterval(t); };
    }, []);

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-background/95 backdrop-blur-md" data-testid="bottom-tab-bar">
            <ul className="flex items-stretch h-[60px]">
                {TABS.map(t => {
                    const active = location.pathname === t.to ||
                                   location.pathname.startsWith(t.to + "/");
                    const Icon = t.icon;
                    const badge = t.badgeKey === "unread" && unread > 0 ? unread : null;
                    return (
                        <li key={t.to} className="flex-1">
                            <Link
                                to={t.to}
                                data-testid={`tab-${t.to.slice(1)}`}
                                className={`relative h-full flex flex-col items-center justify-center gap-1 transition ${
                                    active ? "text-primary-c" : "text-secondary-c"
                                }`}
                            >
                                <Icon size={18} />
                                <span className="text-[10px] font-medium tracking-tight">{t.label}</span>
                                {badge != null && (
                                    <span className="absolute top-1.5 right-[26%] min-w-[16px] h-[16px] px-1 rounded-full bg-error text-white text-[9px] font-mono font-bold flex items-center justify-center" data-testid="tab-badge">
                                        {badge > 9 ? "9+" : badge}
                                    </span>
                                )}
                                {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary rounded-b" />}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
